import { Button, Icon } from '@components/primitives';
import colors from '@theme/colors';
import i18next from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { getChangedLanguage } from './btnLanguageUtils';

const styles = StyleSheet.create({
  button: {
    paddingHorizontal: 10,
    paddingVertical: 5,
  },
});

const changeLanguage = async (): Promise<void> => {
  const selectedLanguage = i18next.language;
  const changeLanguageTo = getChangedLanguage(selectedLanguage);
  await i18next.changeLanguage(changeLanguageTo);
};

const BtnLanguage: React.FC = () => {
  const { t } = useTranslation('common');
  return (
    <Button
      shadow={1}
      variant="ghost"
      testID="btnLanguageChange"
      borderColor={colors.neutral.cotton}
      borderWidth={1}
      backgroundColor={colors.transparent}
      sentry-label="btnLanguageChange"
      _text={{
        testID: 'Language',
        color: colors.neutral.cotton,
        size: 'sm',
        fontWeight: '200',
      }}
      onPress={async () => {
        await changeLanguage();
      }}
      style={styles.button}
      leftIcon={<Icon name="language" family="entypo" color={colors.neutral.cotton} />}>
      {t('common.Language')}
    </Button>
  );
};

export default BtnLanguage;
